

// ########### INIT
jQuery(function ($) {

    // AJAX -- add and remove items to mini-cart
    const update_mini_cart_items = (button, item_key, quantity) => {

        $.ajax({
            type: "POST",
            url: wc_add_to_cart_params.ajax_url,
            data: {
                action: 'sc_update_cart_item_quantity',
                cart_item_key: item_key,
                quantity: quantity,
            },
            beforeSend: function () {
                $('.loader-custom').show()
            },
            complete: function () {
                $('.loader-custom').hide()
            },
            success: function (response) {

                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                }

                $(document.body).trigger("added_to_cart", [
                    response.fragments,
                    response.cart_hash,
                    button,
                ]);
            },
        });
    }

    // add items to mini-cart
    $(document).on("click", "#sidebar-cart .increase-quantity", function (e) {

        e.preventDefault();
        let $button = $(this);

        let current_qty = $button.closest('.woocommerce-item-cart').find('.cart-item-qty').text();
        let new_qty = parseInt(current_qty) + 1;
        $button.closest('.woocommerce-item-cart').find('.cart-item-qty').text(new_qty);
        $(document.body).trigger("adding_to_cart", [$button]);

        update_mini_cart_items($button, $button.attr('data-cart_item_key'), new_qty)
        return false;
    })

    // remove items to mini-cart
    $(document).on("click", "#sidebar-cart .decrease-quantity", function (e) {

        e.preventDefault();
        let $button = $(this);

        let current_qty = $button.closest('.woocommerce-item-cart').find('.cart-item-qty').text();
        let new_qty = parseInt(current_qty) - 1;
        $button.closest('.woocommerce-item-cart').find('.cart-item-qty').text(new_qty);
        $(document.body).trigger("adding_to_cart", [$button]);

        update_mini_cart_items($button, $button.attr('data-cart_item_key'), new_qty)
        return false;
    })

    // add to cart in page cart
    $(document).on('click', 'form.woocommerce-cart-form .increase-quantity', function (e) {
        e.preventDefault();
        let $button = $(this);

        let current_qty = $button.attr('data-quantity');
        let new_qty = parseInt(current_qty) + 1;
        $button.closest('.woocommerce-item-cart').find('.qty').val(new_qty);
        $(document.body).trigger("adding_to_cart", [$button]);

        update_mini_cart_items($button, $button.attr('data-cart_item_key'), new_qty)
        return false;
    })

    // remove to cart in page cart
    $(document).on('click', 'form.woocommerce-cart-form .decrease-quantity', function (e) {
        e.preventDefault();
        let $button = $(this);

        let current_qty = $button.attr('data-quantity');
        let new_qty = parseInt(current_qty) - 1;
        $button.closest('.woocommerce-item-cart').find('.qty').val(new_qty);
        $(document.body).trigger("adding_to_cart", [$button]);

        update_mini_cart_items($button, $button.attr('data-cart_item_key'), new_qty)
        return false;
    })

    // AJAX -- aplicar cupón desde el mini-carrito (evita navegar a wc_get_cart_url(),
    // que rompe cuando el panel se abre desde una página que no es el propio carrito)
    $(document).on('submit', '#sidebar-cart .mini-cart-coupon-form', function (e) {
        e.preventDefault();
        const $form = $(this);

        $.ajax({
            type: 'POST',
            url: wc_add_to_cart_params.ajax_url,
            data: $form.serialize() + '&action=sc_apply_mini_cart_coupon',
            beforeSend: function () {
                $('.loader-custom').show();
            },
            complete: function () {
                $('.loader-custom').hide();
            },
            success: function (response) {
                // Los fragments (totales, cupones aplicados, formulario de cupón limpio)
                // vienen en la misma respuesta: si en vez de esto se dispara un
                // wc_fragment_refresh aparte, esa segunda petición reemplaza todo el
                // mini-carrito y se lleva por delante el aviso que se pinta a continuación.
                if (response && response.fragments) {
                    $.each(response.fragments, function (selector, html) {
                        $(selector).replaceWith(html);
                    });
                }

                const $freshForm = $('#sidebar-cart .mini-cart-coupon-form');
                // inc/cart.php envuelve el <form> en un <div class="... flex items-center
                // gap-2">: insertar el aviso como hermano del propio form lo mete en esa
                // misma fila (por eso salía apretado a la izquierda del input). Se inserta
                // antes de toda la fila para que quede apilado encima, no dentro.
                const $couponRow = $freshForm.parent();

                // El fragment reemplazado trae el <details> del cupón cerrado por defecto:
                // sin esto, el aviso de éxito/error queda oculto justo cuando hace falta verlo.
                $freshForm.closest('details').prop('open', true);

                $couponRow.siblings('.woocommerce-error, .woocommerce-message, .woocommerce-info').remove();

                if (response && response.notices) {
                    $couponRow.before(response.notices);
                }

                $(document.body).trigger('wc_fragments_refreshed');
            },
        });

        return false;
    });

    const spinner = $('.content-spinner-loader');

    $(document.body).on('adding_to_cart wc_fragment_refresh updated_cart_totals', function () {
        spinner.removeClass('hidden').addClass('flex');
    });

    $(document.body).on('added_to_cart wc_fragments_refreshed updated_wc_div', function () {
        setTimeout(() => {
            spinner.removeClass('flex').addClass('hidden');
        }, 500);
    });

    $(document.body).on('wc_fragments_refreshed wc_fragment_refresh added_to_cart removed_from_cart', function (e) {
        lucide.createIcons(); // reinit icons
    });
});

